import { get, put } from '../services/common/common.service';
import { eTrackSettingEndPoints } from '../constants/endpoint';

export const fetchEntitelmentSetup = () =>
  get(eTrackSettingEndPoints.entitelment);

export const updateEntitelmentSetup = (payload) =>
  put(eTrackSettingEndPoints.entitelment, payload);

export const fetchSalesImport = () => get(eTrackSettingEndPoints.salesImport);

export const updateSalesImport = (payload) =>
  put(eTrackSettingEndPoints.salesImport, payload);

export const fetchAccountingGroup = () =>
  get(eTrackSettingEndPoints.accountiGroup);

export const updateAccountingGroup = (payload) =>
  put(eTrackSettingEndPoints.accountiGroup, payload);
